import AuditGateway from './AuditGateway'
import AuditTimelineModel from './AuditTimelineModel'
import AuditListModel from './AuditListModel'
import moment from 'moment';

export default class AuditService {
  constructor (auditGateway) {
    this.AuditGateway = auditGateway || new AuditGateway()

    this.getAllAudit = this.getAllAudit.bind(this)
    this.getAuditById = this.getAuditById.bind(this)
    this.getAuditCreatedBy = this.getAuditCreatedBy.bind(this)
  }

  getAllAudit () {
    return this.AuditGateway
      .getAllAudit()
      .then(response => {
        response.sort((left, right) => {
          return moment.utc(left.createdDate).diff(moment.utc(right.createdDate))
        }).reverse()
        return response.map((item) => new AuditTimelineModel(item))
      })
  }

  getAuditById (params) {
    return this.AuditGateway
    .getAuditById(params)
    .then(response => new AuditListModel(response.entries))
  }

  getAuditCreatedBy (params) {
    return this.AuditGateway
    .getAuditCreatedBy(params)
    .then(response => response)
  }
}



// WEBPACK FOOTER //
// ./src/api/audit/AuditService.js